import { PropsWithChildren, createContext, useContext } from 'react';
import { usePlacesAutocompleteService } from 'rwl-ui';

type PlacesAutocompleteContextType = {
    clearSelectedPlaceId: () => void;
} & ReturnType<typeof usePlacesAutocompleteService>;

const PlacesAutocompleteContext = createContext<
    PlacesAutocompleteContextType | undefined
>(undefined);

type PlacesAutocompleteProviderProps = unknown;

export const PlacesAutocompleteProvider = ({
    children,
}: PropsWithChildren<PlacesAutocompleteProviderProps>) => {
    const placesAutocompleteService = usePlacesAutocompleteService();

    return (
        <PlacesAutocompleteContext.Provider
            value={{
                ...placesAutocompleteService,
                clearSelectedPlaceId: () => {
                    placesAutocompleteService.setSelectedPlaceId(undefined);
                },
            }}
        >
            {children}
        </PlacesAutocompleteContext.Provider>
    );
};

export const usePlacesAutocomplete = () => {
    const context = useContext(PlacesAutocompleteContext);
    if (context === undefined) {
        throw new Error(
            'usePlacesAutocomplete must be used within a PlacesAutocompleteProvider'
        );
    }
    return context;
};
